module.exports = __webpack_public_path__ + "img/children_icon.7956131d.svg";